import { PARTNER360_NAMESPACE } from '../common/constants'

export const PARTNER360_SECTION_SETTINGS_NAMESPACE = `${PARTNER360_NAMESPACE}/sectionSettings`

// Async thunk constants
export const REQUEST_SECTION_SETTINGS = `${PARTNER360_SECTION_SETTINGS_NAMESPACE}/requestSectionSettings`
export const UPDATE_SECTION_SETTINGS = `${PARTNER360_SECTION_SETTINGS_NAMESPACE}/updateSectionSettings`
